/**
 * Computes the intersection between two sets.
 * @param setA The first set
 * @param setB The second set
 * @returns The intersection of setA and setB.
 */
export default function setIntersection<T>(setA: Set<T>, setB: Set<T>): Set<T> {
  return new Set([...setA].filter((elem) => setB.has(elem)));
}
